<template>

	<v-container>
    <v-layout column justify-center align-center>
      <v-flex shrink class="mt-16">
        <v-img
          alt="Cellsmart Logo"
          class="shrink mr-2"
          contain
          src="@/assets/logo.png"
          transition="scale-transition"
          width="250"
        />
      </v-flex>
      <div class="subheading mt-2 mb-15">Accounts</div>
    </v-layout>
    <v-card-text>
			<h2>{{ $t('pageHeader.forgotPassword') }}</h2>
			<div v-if="emailSent">
				<v-layout column>
					Email sent!
					<v-btn data-cy="forgotPasswordEmailSentBtn" to="/login">Login</v-btn>
				</v-layout>

			</div>
			<div v-else>
				Enter email to receive password reset link.
				<v-text-field
				v-model="email"
				:error-messages="emailErrors"
				data-cy="forgotPasswordEmail"
				:label="$t('labels.email')"
				>
				</v-text-field>
				<v-btn data-cy="forgotPasswordCancelBtn" to="/login">Cancel</v-btn>
				<v-btn data-cy="forgotPasswordSendBtn" @click="submit">Send Email</v-btn>
			</div>
		</v-card-text>
	</v-container>
</template>
<script>
import authService from '../Authentication/service'

const { validationMixin } = require('vuelidate')
const { required, email } = require('vuelidate/lib/validators')

export default {
  name: 'forget-password',
  data() {
    return {
      email: null,
      emailSent: false,
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toast.error('Invalid Input', {
          position: 'top-right',
          showHideTransition: 'slide',
          duration: 2000,
        })
      } else {
        this.$Progress.start()
        authService.forgetPassword({
          email: this.email,
					cciUser: true
        }).then(() => {
          this.$Progress.finish()
          this.emailSent = true
        })
          .catch((error) => {
            this.$Progress.fail()
            console.log(error)
          })
      }
    },
  },
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      if (!this.$v.email.email) errors.push('Email is not valid')
      if (!this.$v.email.required) errors.push('Email is required.')
      return errors
    },
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required,
    },
  },
}
</script>
